(function () {
  'use strict';
  function init() {
    var control = document.querySelector('[data-nt-stock-control]');
    if (!control || control.dataset.ready) return;
    control.dataset.ready = 'true';
    var root = control.closest('main');
    var grid = root.querySelector('[data-nt-model-products], .nt-collection-product-grid');
    if (!grid) return;
    var toggle = control.querySelector('[data-nt-stock-toggle]');
    var status = control.querySelector('[data-nt-stock-status]');
    var locked = control.dataset.ntStockLocked === 'true';
    var count = root.querySelector('[data-nt-stock-count]');
    var originalCount = count ? count.textContent : '';
    var nativePager = root.querySelector('.nt-pagination');
    var originalNodes = Array.from(grid.childNodes);
    var modelItems = Array.from(grid.querySelectorAll('.nt-model-category__item'));
    var localMode = modelItems.length > 0 && !nativePager;
    var active = false;
    var controller = null;
    var stockCards = null;
    var pager = null;
    var page = 0;
    var pageSize = 24;
    var empty = document.createElement('p');
    empty.className = 'nt-empty';
    empty.textContent = 'No US-stock products match this selection. Turn off US STOCK ONLY to see all styles.';
    function keepFilterInForms() {
      root.querySelectorAll('form[method="get"]').forEach(function (form) {
        var field = form.querySelector('input[name="nt_stock"]');
        if (active && !field) {
          field = document.createElement('input'); field.type = 'hidden'; field.name = 'nt_stock'; form.appendChild(field);
        }
        if (field) { field.value = '1'; field.disabled = !active; }
      });
    }
    function updateURL() {
      var url = new URL(location.href);
      if (active) url.searchParams.set('nt_stock', '1'); else url.searchParams.delete('nt_stock');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
      keepFilterInForms();
    }
    function showStockPage() {
      var total = stockCards.length;
      var pages = Math.max(1, Math.ceil(total / pageSize));
      page = Math.max(0, Math.min(page, pages - 1));
      grid.replaceChildren.apply(grid, stockCards.slice(page * pageSize, (page + 1) * pageSize));
      if (!total) grid.appendChild(empty);
      if (count) count.textContent = total + ' US-stock ' + (total === 1 ? 'product' : 'products');
      if (!pager) {
        pager = document.createElement('nav'); pager.className = 'nt-stock-filter-pager'; pager.setAttribute('aria-label', 'US-stock product pages');
        var prev = document.createElement('button'); prev.type = 'button'; prev.textContent = '← Previous';
        var label = document.createElement('span');
        var next = document.createElement('button'); next.type = 'button'; next.textContent = 'Next →';
        prev.addEventListener('click', function () { page--; showStockPage(); grid.scrollIntoView({block:'start'}); });
        next.addEventListener('click', function () { page++; showStockPage(); grid.scrollIntoView({block:'start'}); });
        pager.append(prev, label, next); grid.after(pager);
      }
      pager.hidden = pages <= 1;
      pager.children[0].disabled = page === 0;
      pager.children[1].textContent = (page + 1) + ' / ' + pages;
      pager.children[2].disabled = page >= pages - 1;
    }
    async function loadStock(signal) {
      var url = new URL(location.href);
      var base = new URL(control.dataset.collectionUrl, location.origin).pathname;
      var tags = url.pathname.slice(base.length).replace(/^\//, '').split('+').filter(Boolean);
      if (tags.indexOf('available-in-usa') === -1) tags.push('available-in-usa');
      url.pathname = base + '/' + tags.join('+');
      url.searchParams.delete('nt_stock'); url.searchParams.delete('page'); url.searchParams.set('view', 'nt-stock-items');
      var cards = [], seen = new Set(), visited = new Set();
      while (true) {
        if (visited.has(url.href)) throw new Error('Repeated page');
        visited.add(url.href);
        var response = await fetch(url.href, {credentials:'same-origin', signal:signal});
        if (!response.ok) throw new Error('Stock listing unavailable');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var feed = doc.querySelector('[data-nt-stock-feed]');
        if (!feed) throw new Error('Stock listing missing');
        feed.querySelectorAll('.nt-product-card[data-nt-us-stock="true"]').forEach(function (card) {
          var handle = card.dataset.ntProductHandle;
          if (!seen.has(handle)) { seen.add(handle); cards.push(document.importNode(card, true)); }
        });
        if (!feed.dataset.nextPage) break;
        url.searchParams.set('page', feed.dataset.nextPage);
      }
      return cards;
    }
    async function setActive(value, changeURL) {
      active = value;
      if (controller) controller.abort();
      controller = null;
      toggle.setAttribute('aria-pressed', String(active));
      status.textContent = '';
      grid.removeAttribute('aria-busy');
      if (changeURL) updateURL(); else keepFilterInForms();
      if (!active) {
        empty.remove();
        if (localMode) modelItems.forEach(function (item) { item.hidden = false; });
        else grid.replaceChildren.apply(grid, originalNodes);
        if (count) count.textContent = originalCount;
        if (nativePager) nativePager.hidden = false;
        if (pager) pager.hidden = true;
        return;
      }
      if (localMode) {
        var visible = 0;
        modelItems.forEach(function (item) { item.hidden = item.dataset.stockGroup !== 'in-stock'; if (!item.hidden) visible++; });
        if (!visible) grid.appendChild(empty);
        if (count) count.textContent = visible + ' US-stock ' + (visible === 1 ? 'style' : 'styles');
        return;
      }
      if (nativePager) nativePager.hidden = true;
      if (stockCards) { page = 0; showStockPage(); return; }
      var request = new AbortController(); controller = request;
      status.textContent = 'Finding US-stock products…'; grid.setAttribute('aria-busy', 'true');
      try {
        var loaded = await loadStock(request.signal);
        if (!active || request.signal.aborted) return;
        stockCards = loaded; page = 0; showStockPage(); status.textContent = '';
      } catch (error) {
        if (request.signal.aborted) return;
        await setActive(false, true);
        status.textContent = 'Stock filter could not load. Please try again.';
      } finally {
        if (controller === request) { controller = null; grid.removeAttribute('aria-busy'); }
      }
    }
    toggle.hidden = locked;
    if (!locked) toggle.addEventListener('click', function () { setActive(!active, true); });
    root.addEventListener('click', function (event) {
      if (!active) return;
      var link = event.target.closest('a[href]');
      if (!link) return;
      var url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === new URL(control.dataset.collectionUrl, location.origin).pathname) {
        url.searchParams.set('nt_stock', '1'); link.href = url.href;
      }
    });
    window.addEventListener('popstate', function () { setActive(new URL(location.href).searchParams.get('nt_stock') === '1', false); });
    if (locked || new URL(location.href).searchParams.get('nt_stock') === '1') setActive(true, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
